import { render } from "./ProjectArchitecture.vue?vue&type=template&id=d4572eec"
import script from "./ProjectArchitecture.vue?vue&type=script&lang=js"
export * from "./ProjectArchitecture.vue?vue&type=script&lang=js"

import "./ProjectArchitecture.vue?vue&type=style&index=0&id=d4572eec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__